













import { defineComponent } from '@vue/composition-api';

export default defineComponent({
  props: {
    tooltip: {
      type: String,
      default: '',
    },
    showTooltip: {
      type: Boolean,
      default: true,
    },
  },
});
